const isInitialPaymentReducer = (state = false, action) => {
  switch (action.type) {
    case "INITIAL_PAYMENT_DONE":
      return true;
    default:
      return state;
  }
};

export default isInitialPaymentReducer;
